import api from './api';

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// // Create axios instance with default config
// const api = axios.create({
//   baseURL: API_URL,
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

const systemCaregiverService = {
  // Create system caregiver
  createSystemCaregiver: async (caregiverData) => {
    const response = await api.post('/system-caregivers', caregiverData);
    return response;
  },

  // Get all system caregivers
  getSystemCaregivers: async (params = {}) => {
    const response = await api.get('/system-caregivers', { params });
    return response;
  },

  // Get system caregiver by ID
  getSystemCaregiver: async (caregiverId) => {
    const response = await api.get(`/system-caregivers/${caregiverId}`);
    return response;
  },

  // Get system caregiver by ID (alias for consistency)
  getSystemCaregiverById: async (caregiverId) => {
    const response = await api.get(`/system-caregivers/${caregiverId}`);
    return response;
  },

  // Get patients for a system caregiver
  getSystemCaregiverPatients: async (caregiverId, params = {}) => {
    const response = await api.get(`/system-caregivers/${caregiverId}/patients`, { params });
    return response;
  },

  // Update system caregiver
  updateSystemCaregiver: async (caregiverId, caregiverData) => {
    const response = await api.put(`/system-caregivers/${caregiverId}`, caregiverData);
    return response;
  },

  // Delete system caregiver
  deleteSystemCaregiver: async (caregiverId) => {
    const response = await api.delete(`/system-caregivers/${caregiverId}`);
    return response;
  }
};

export default systemCaregiverService;
